import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./styles.scss";
import { FaInstagram, FaWhatsapp, FaYoutube, FaTelegramPlane, FaTiktok } from "react-icons/fa";
import Logo from "./../../assets/img/logo-portal-temp-1.png";

export default function Footer() {
    return (
        <>
            <div className="" style={{ backgroundColor: "#FFD700", height: "5px" }} ></div>
            <div className="main-footer bg-primary">
                <Container fluid>
                    <Row className="pt-4 justify-content-center">

                        <Col style={{ color: 'white' }}>
                            <h5 style={{ color: '#fdcc01' }}>Quem somos?</h5>
                            <p>Somos uma comunidade que nasceu com a
                                missão de ajudar o consumidor brasileiro a
                                economizar e fazer a melhor escolha!</p>

                        </Col>
                        <Col xs={6} md="auto">

                            <div><Link to="/" className="text-md-left">Últimas notícias</Link></div>
                            <div>
                                <a
                                    href="https://cacadores-de-ofertas.com/sobre"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Grupos de Oferta
                                </a>
                            </div>
                            <div><Link to="/contato">Termos e condições</Link></div>
                            <div><Link to="/contato">Política de privacidade</Link></div>
                        </Col>
                        <Col xs={6} md="auto" className="order-md-2">
                            <Row className="justify-content-center justify-content-md-end">
                                <Col xs="auto">
                                    <a
                                        href="https://www.youtube.com/@cacadoresofertas"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <FaYoutube className="p-2 social-links" size="48" />
                                    </a>
                                </Col>
                                <Col xs="auto">
                                    <a
                                        href="https://instagram.com/cacadores.ofertas"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <FaInstagram className="p-2 social-links" size="48" />
                                    </a>
                                </Col>
                                <Col xs="auto">
                                    <a
                                        href="https://chat.whatsapp.com/IPrFvbirmIzIz35CzCzi08"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <FaTiktok className="p-2 social-links" size="48" />
                                    </a>
                                </Col>
                                <Col xs="auto">
                                    <a
                                        href="https://chat.whatsapp.com/IPrFvbirmIzIz35CzCzi08"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <FaWhatsapp className="p-2 social-links" size="48" />
                                    </a>
                                </Col>

                                <Col xs="auto">
                                    <a
                                        href="https://t.me/s/cacadoresofertas"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <FaTelegramPlane className="p-2 social-links" size="48" />
                                    </a>
                                </Col>
                            </Row>
                        </Col>

                    </Row>


                    <div style={{ padding: "15px" }}></div>

                    <Row className="justify-content-center">
                        <Col xs="auto" className="text-white">
                            {` 2022-${new Date().getFullYear()} Caçadores de Ofertas © Todos os direitos reservados.`}
                        </Col>

                    </Row>
                </Container>
            </div>
        </>
    );
}

